import React from "react";
import { useLocation } from "react-router-dom";
import CachedIcon from "@mui/icons-material/Cached";
import { useNavigate } from "react-router-dom";
import "./HeaderContent.css";

// Mirrors the nav labels in MenuTop so the banner never contradicts the item
// the customer just clicked - falls back to the capitalized route slug for
// any route not listed here instead of blocking on it.
const PAGE_TITLES = {
  "/": "Dashboard",
  "/dashboard": "Dashboard",
  "/accounts": "My Sites",
  "/proposals": "My Proposals",
  "/invoices": "My Invoices",
  "/reports": "Reports",
  "/notifications": "Notifications",
};

export function HeaderContent() {
  const location = useLocation();
  const navigate = useNavigate();

  const locationName = location.pathname?.slice(1);
  const pageTitle = PAGE_TITLES[location.pathname] || locationName;

  const reload = () => navigate(0);

  return (
    <div className="header-content">
      <div className="header-content__inner">
        <div className="header-content__title">
          <button
            type="button"
            className="header-content__refresh"
            onClick={reload}
            aria-label="Reload page"
          >
            <CachedIcon />
          </button>
          <span className="header-content__page">{pageTitle}</span>
        </div>
        <div className="header-content__actions">
          {/* <MiscellaneousServicesIcon style={{ fontSize: 25 }} /> */}
        </div>
      </div>
    </div>
  );
}
